// eslint-disable-next-line no-unused-vars
import React from 'react'
/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import slackLogo from '../slack-logo.png'

const wrapperCss = css`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const contentCss = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;
`

const logoWrapperCss = css`
  > img {
    width: 48px;
    height: 48px;
  }
`

const infoCss = css`
  flex-grow: 2;
  margin-left: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 252px;
  text-align: center;

  > h4 {
    margin-top: 12px;
    margin-bottom: 12px;
  }
`

const NoAccess = () => {
  return (
    <div css={wrapperCss}>
      <div css={contentCss}>
        <div css={logoWrapperCss}>
          <img src={slackLogo} alt="" />
        </div>

        <div css={infoCss}>
          <h4>Access Denied</h4>

          <div>
            You don't have access to connect this integration. Please contact
            the owner or admin from your license.
          </div>
        </div>
      </div>
    </div>
  )
}

export default NoAccess
